import React, { Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { Button, Pagination, PaginationItem, PaginationLink } from 'reactstrap/lib';
import { getFilteredTransactions } from '../../../actions/admin';
import Moment from 'react-moment';
import TransactionPlayerName from './components/TransactionPlayerName';

import { filter } from 'lodash';
import * as constants from '../../../constants/constants';

const UnfinishedTransactions = ({ offset }) => {
  const dispatch = useDispatch();
  // "Unfinished" means not completed: statuses like "initiated" and "failed"
  const allPayments = useSelector(
    state => (state.admin.allPayments || []).filter(payment => payment?.status !== 'completed')
  );

  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const pagesCount = allPayments.length > 0 ? Math.ceil(allPayments.length / pageSize) : 1;
  
  const handleClick = (e, index) => {
    e.preventDefault();
    
    setCurrentPage(index);
  };

  
  useEffect(() => {
    dispatch(getFilteredTransactions('all', null, null, null, 'initiatedPayments', '', null, 'unfinished'));
  }, []);

  return (
    <Fragment>
      <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-all-transactions">
        <PopoverBody className="popover-body">
          A list of all initiated, unfinished transactions in the game.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <h2>
          Unfinished Transactions
          <Button className="admin-help-button" id="admin-help-button-all-transactions">
            ?
          </Button>
        </h2>
        <div className="col-md-12 admin-page-content-table">
          
        </div>
        <div>
            <div className="admin-page-content-table-body">
              <table style={{ width: '100%', fontSize: 12, textAlign: 'center' }}>
                <colgroup>
                  <col span="1" className="" />
                </colgroup>
              </table>
            </div>
          <table style={{ width: '100%', fontSize: 12, textAlign: 'center' }}>
            <colgroup>
              <col span="1" className="" />
            </colgroup>
            <thead>
              <tr>
                <th>
                  Date
                </th>
                <th>
                  Player Id
                </th>
                <th>
                  Player Name
                </th>
                <th>
                  Status
                </th>
                <th>
                  Provider
                </th>
                <th>
                  Reason
                </th>
              </tr>
            </thead>
            <tbody>
              {allPayments && allPayments.length > 0 && allPayments.slice(
                currentPage * pageSize,
                (currentPage + 1) * pageSize,
              )
                .map((payment, index) => (
                  <Fragment key={payment.id}>
                    {console.log('payment test', payment)}
                    <tr key={payment.id} className={`allUsers-table-row ${index % 2 === 0 ? ('odd') : ('even')}`}>
                      <td className="allUsers-table-col">
                        <Moment format="DD-MM-YYYY, HH:mm" locale="lv">
                          {payment.date + offset}
                        </Moment>
                      </td>
                      <td className="allUsers-table-col">
                        { payment.userUid }
                      </td>
                      <td className="allUsers-table-col">
                        {
                          payment.userName ? payment.userName : payment?.paymentInfo?.name ? payment?.paymentInfo?.name : (
                            <TransactionPlayerName userId={payment.userUid} />
                          )
                        }
                      </td>
                      <td className="allUsers-table-col">
                        { payment.status }
                      </td>
                      <td className="allUsers-table-col">
                        { payment.provider }
                      </td>
                      <td className="allUsers-table-col">
                        { payment?.paymentInfo?.source ?? ''}
                      </td>
                    </tr>
                  </Fragment>
                ))}
                {allPayments.length > pageSize && (
                  <div className="pagination-wrapper">
                    <Pagination aria-label="Page navigation example">
                      <PaginationItem disabled={currentPage === 0}>
                        <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, 0)} href="#">
                          {`‹‹‹`}
                        </PaginationLink>
                      </PaginationItem>

                      <PaginationItem disabled={currentPage <= 0}>
                        <PaginationLink
                          style={{ color: '#000' }}
                          onClick={e => handleClick(e, currentPage - 1)}
                          previous
                          href="#"
                        />
                      </PaginationItem>

                      {[...Array(pagesCount)].map((page, i) => {
                        if (i > currentPage - 3 && i < currentPage + 3) {
                          return (
                            <PaginationItem active={i === currentPage} key={page}>
                              <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, i)} href="#">
                                {i + 1}
                              </PaginationLink>
                            </PaginationItem>
                          );
                        }

                        return null;
                      })}

                      <PaginationItem disabled={currentPage >= pagesCount - 1}>
                        <PaginationLink
                          style={{ color: '#000' }}
                          onClick={e => handleClick(e, currentPage + 1)}
                          next
                          href="#"
                        />
                      </PaginationItem>

                      <PaginationItem disabled={currentPage >= pagesCount - 1}>
                        <PaginationLink style={{ color: '#000' }} onClick={e => this.handleClick(e, pagesCount - 1)} href="#">
                          {`›››`}
                        </PaginationLink>
                      </PaginationItem>
                    </Pagination>
                  </div>
                )}
            </tbody>
          </table>
        </div>
      </div>
    </Fragment>
  );
};

export default UnfinishedTransactions;